// LIBRARIES
import { createAsyncThunk } from "@reduxjs/toolkit";

// MISC
import { REST } from "config/axiosConfig";
import { ISelectUsersApiParams, IUsersApiParams } from "models/interfaces";

export const getAllUsers = createAsyncThunk(
  "user/getAllUsers",
  async (data: IUsersApiParams) => {
    try {
      const response = await REST.post(
        `/user/get-all-users?${data.endDate && `endDate=${data.endDate}`}${data.page && `&page=${data.page}`
        }&size=7${data.startDate && `&startDate=${data.startDate}`}${data.userStatus && `&userStatus=${data.userStatus}`
        }`,
        data.fullName
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export const getAllSelectUsers = createAsyncThunk(
  "user/getAllUsers",
  async (data: ISelectUsersApiParams) => {
    try {
      const response = await REST.post(
        `/user/get-all-users?page=${data.page}&size=10`,
        data.fullName
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export const addToBlackList = createAsyncThunk(
  "user/addToBlacklist",
  async (id: number) => {
    try {
      const response = await REST.post(`/user/add-to-blacklist?userId=${id}`);
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export const removeFromBlacklist = createAsyncThunk(
  "user/removeFromBlacklist",
  async (id: number) => {
    try {
      const response = await REST.post(
        `/user/remove-from-blacklist?userId=${id}`
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export const changeUserStatusVerified = createAsyncThunk(
  "user/changeUserStatusVerified",
  async (id: number) => {
    try {
      const response = await REST.post(`/user/change-user-status-verified?userId=${id}`);
      return response.data;
    } catch (err) {
      return err;
    }
  }
);
